import { ActionCreator } from "redux";
import { PUSH_NEW_ROUTE } from "./constants";
import { PushRouterAction } from "./types";

export const push: ActionCreator<PushRouterAction> = (route:string) => ({
    type: PUSH_NEW_ROUTE,
    payload: {
        route
    }
});


// WEBPACK FOOTER //
// ./src/store/Routing/actions.ts